import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { UncontrolledTooltip } from 'reactstrap';

import { showConfirmationModal } from '../../actions/App';

import { APIunsyncCollection } from '../../api/Collections';

const SyncedCollectionsListItem = ({
  intl,
  collection,
  handelUnsyncCollection,
  loadSyncedCollections,
}) => {
  const afterUnsyncCollection = () => {
    loadSyncedCollections();
  };

  return (
    <tr>
      <td className="synced-collection file-image">
        <Link to={`/collections/${collection.uuid}`} target="_blank" className="list-item-img-wrapper">
          <img
            id={`upload-img-${collection.uuid}`}
            className="list-item-img"
            width="100%"
            src={collection.featured_file?.urls.thumbnail}
            alt=""
          />
        </Link>
      </td>
      <td className="synced-collection-name">
        <Link to={`/collections/${collection.uuid}`} target="_blank" className="list-item-img-wrapper">
          {collection.name}
        </Link>
      </td>
      <td className="action-more">
        <a
          href="#unsync"
          id={`unsync-collection-${collection.uuid}`}
          onClick={(e) => {
            e.preventDefault();
            handelUnsyncCollection(collection, () => afterUnsyncCollection());
          }}
        >
          <i className="fas fa-rotate-exclamation" />
        </a>
        <UncontrolledTooltip target={`unsync-collection-${collection.uuid}`} placement="top">
          {intl.formatMessage({ defaultMessage: 'Unsync collection' })}
        </UncontrolledTooltip>
      </td>
    </tr>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  workspaceColor: state.App.settings.color,
  client: state.Auth.profile?.client,
});

const mapDispatchToProps = (dispatch, props) => ({
  handelUnsyncCollection: (collection, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({ defaultMessage: 'Are you sure you want to unsync this collection?' }),
      onConfirm: () => (
        APIunsyncCollection(collection.uuid).then(() => {
          callback(collection);
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

SyncedCollectionsListItem.propTypes = {
  intl: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
  loadSyncedCollections: PropTypes.func.isRequired,
  handelUnsyncCollection: PropTypes.func.isRequired,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SyncedCollectionsListItem));
